import Text from './Text';
import styles from '../pages/Sellbot.module.css';

export default function SellbotPausedBadge() {
    return (
        <span class={`${styles.badge} ${styles.badgePaused}`}>
            <i class="fa-solid fa-circle-pause" />
            <Text val="SELLBOT_PAUSED" />
        </span>
    );
}
